/**
 * @fileoverview POST handler for the "/:app_group_id/figma/file_nodes" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { postAppGroupIdFigmaFileNodesCacheKeys } from "./constants";
import type {
  PostAppGroupIdFigmaFileNodesProps,
  PostAppGroupIdFigmaFileNodesResult,
  PostAppGroupIdFigmaFileNodesResultErrors,
} from "./types";

export const postAppGroupIdFigmaFileNodes = reactQueryMutationAdapter(
  postAppGroupIdFigmaFileNodesCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdFigmaFileNodesResultErrors>()(
    (props: PostAppGroupIdFigmaFileNodesProps): Promise<PostAppGroupIdFigmaFileNodesResult> => {
      return fetch(
        `/${props.appGroupId}/figma/file_nodes`,
        "POST",
        {
          file_key: props.fileKey,
          ids: props.ids,
          ...(props.depth !== undefined && { depth: props.depth }),
          ...(props.geometry !== undefined && { geometry: props.geometry }),
          ...(props.pluginData !== undefined && { plugin_data: props.pluginData }),
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
